import React from "react";
import LmsTable from "../ui/LmsTable";

const LmsFundsFundCapacity = () => {
  return <LmsTable
    actionButtons={["export"]}
    apiSuffix="funds/fund-capacity"
    sortable={["Created On"]}
    columnLabelsDictionary={{ fundOrganization: "Fund" }}
    dataRules={[
      { field: "equityTotal", rule: "format", display: "dollar" },
      { field: "capacity", rule: "format", display: "dollar" },
      { field: "commitmentAmount", rule: "format", display: "dollar" },
      { field: "availableCapacity", rule: "format", display: "dollar" },
    ]}
    skipClick
  />;
};

export default LmsFundsFundCapacity;